import { route } from '@helpers'
import useAuth from "@hooks/useAuth"
import React from 'react'
import { Redirect, Route, RouteProps } from "react-router-dom"

/**
 * If user's role doesn't match with needed, 
 * redirects to the home page of the user based on role.
 * Or if user doesn't have role, to the welcome page.
 */
export default function role(role: Interfaces.Role["name"]) {
    return ({ children, component, ...props }: RouteProps) => {
        const { user } = useAuth()
        if (user.role?.name !== role) return <Redirect to={route(user.role.name ?? 'welcome')} />  
        if (component) return <Route {...props} component={component} />
        return <Route {...props}>{children}</Route>    
    }
}